module.exports = __webpack_public_path__ + "static/media/XDC.334925ad.svg";